module.exports = __webpack_public_path__ + "static/media/8OLA27.9d5f6507.jpg";